import { memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { debounce } from 'lodash'
import style from './index.module.scss'
import { Button, Empty, Tag, Spin, Table as ATable } from 'antd'
import Table from '@/components/Table'
import Shape from '@/assets/images/shape.png'
import emptyImg from '@/assets/icons/empty.svg'
import styles from './index.module.scss'
import WalletButton from '@/components/WalletButton'
import addAutoSweep from '@/assets/images/addAutoSweep.png'
import Modal from '@/components/Modal'
import { AutoSweepAuditStatus } from '@/constants/enum'
import cls from 'classnames'
import Delete from '@/assets/images/delete.png'
import SweepDrawer from '../SweepDrawer'
import { useGetAutoSweepRuleList } from '@/hooks/sweep'
import {
  AutoSweepOperateType,
  AutoSweepRuleDetailModel,
  AutoSweepRuleModel,
} from '@/services/apis/policy/model'
import policy from '@/services/apis/policy'
import { getWalletTagName } from '@/utils/utils'
import sweep from '@/services/apis/sweep'
import emitter from '@/utils/event'
import { NO_PERMISSION_EVENT, REFRESH_SWEEP_RULE_LIST } from '@/constants/event'
import { handleSweepI18nTip } from '@/utils/utils'
import NetworkLogo from '@/components/NetworkLogo'
import { isNil } from 'lodash'
import ApprovalFlow from '../Approval/index'
import base from '@/services/apis/base'
import { toThousands } from '@/utils/number'
import { useLocation, useNavigate } from 'react-router-dom'
import { useCheckBackupStatus } from '@/hooks/user'
import { SweepConfig } from '@/services/apis/sweep/models'
const autoSweep = memo(() => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [pendingModifyRule, setPendingModifyRule] = useState<AutoSweepRuleDetailModel>()
  const [ruleDetailMap, setRuleDetailMap] = useState<{ [key: string]: AutoSweepRuleDetailModel }>(
    {}
  )
  const [forceUpdateRuleList, setForceUpdateRuleList] = useState({})
  const rules = useGetAutoSweepRuleList(forceUpdateRuleList)
  const [baseConfig, setBaseConfig] = useState<SweepConfig>({} as SweepConfig)
  // 获取链接
  const handleGetConfig = async () => {
    const res = await base.getSweepConfig()
    if (res.success) {
      setBaseConfig(res.data)
    }
  }
  const checkBackupStatus = useCheckBackupStatus()
  useEffect(() => {
    emitter.on(REFRESH_SWEEP_RULE_LIST, () => {
      setForceUpdateRuleList({})
      setRuleDetailMap({})
    })
    handleGetConfig()
    return () => emitter.off(REFRESH_SWEEP_RULE_LIST)
  }, [])
  useEffect(() => {
    emitter.on(NO_PERMISSION_EVENT, () => {
      Modal.info({
        title: t('autoSweep.permission'),
        content: <div className={styles.confirm}>{t('autoSweep.noPermission')}</div>,
        okText: t('common.complete'),
        onOk() {
          navigate('/application')
        },
        closable: true,
      })
    })
    return () => emitter.off(NO_PERMISSION_EVENT)
  }, [])
  useEffect(() => {
    checkBackupStatus().then(isBackup => {
      if (!isBackup) {
        Modal.info({
          title: t('autoSweep.notBackup.title'),
          content: <div className={styles.confirm}>{t('autoSweep.notBackup.desc')}</div>,
          okText: t('common.complete'),
          afterClose() {
            navigate('/application')
          },
          closable: true,
        })
      }
    })
  }, [])
  // 动态获取class类
  function txStatusColorClass(value: AutoSweepAuditStatus) {
    const colorMap = {
      [AutoSweepAuditStatus.NOSUBMITTED]: styles.normal,
      [AutoSweepAuditStatus.INAPPRVAL]: styles.waiting,
      [AutoSweepAuditStatus.PASSED]: styles.success,
      [AutoSweepAuditStatus.REJECT]: styles.danger,
      [AutoSweepAuditStatus.CANCELLED]: styles.danger,
    }
    return colorMap[value]
  }
  function getAuditStatusText(value: AutoSweepAuditStatus, operateType: AutoSweepOperateType) {
    switch (value) {
      case AutoSweepAuditStatus.NOSUBMITTED:
        return t('policy.notSubmit')
      case AutoSweepAuditStatus.PASSED:
        return t('policy.passed')
      case AutoSweepAuditStatus.CANCELLED:
        return t('enum.txStatus.Cancelled')
      case AutoSweepAuditStatus.INAPPRVAL:
        switch (operateType) {
          case AutoSweepOperateType.AUTOSWEEP_RULE_UPDATE:
            return t('policy.updatePending')
          case AutoSweepOperateType.AUTOSWEEP_RULE_DEL:
            return t('policy.delPending')
        }
        return t('policy.pending')
      case AutoSweepAuditStatus.REJECT:
        switch (operateType) {
          case AutoSweepOperateType.AUTOSWEEP_RULE_UPDATE:
            return t('policy.updateReject')
          case AutoSweepOperateType.AUTOSWEEP_RULE_DEL:
            return t('policy.delReject')
        }
        return t('policy.reject')
    }
  }
  // 展开行
  function renderExpand(record: AutoSweepRuleModel) {
    const detail = ruleDetailMap[record.modifyKey] || record
    return (
      <div className={style.expandBox}>
        <div className={style.left}>
          <div className={style.line} style={{ marginBottom: '40px' }}>
            <div className={style.title}>{t('autoSweep.sweepWallet')}</div>
            <div
              dangerouslySetInnerHTML={{
                __html: handleSweepI18nTip(t, baseConfig),
              }}
            />
          </div>
          <div className={style.line}>
            <div className={style.title}>{t('autoSweep.destWallet')}</div>
            <div>
              {detail.destinationName} ({getWalletTagName(detail.destinationType, t)})
            </div>
            <div>{detail.destinationAddress}</div>
          </div>
        </div>
        <div style={{ width: '1px', backgroundColor: '#DEE2E2', margin: '0 85px' }}></div>
        <div className={style.right}>
          <div className={style.line}>
            <div className={style.title}>{t('autoSweep.transactionConfiguration')}</div>
            <div className={style.lineBox}>
              <div className={style.lineLeft}>{t('autoSweep.collectionFrequency')}:</div>
              <div className={style.lineRight}>
                {t('autoSweep.frequencyCount', { x: detail.sweepRate })}
              </div>
            </div>
          </div>
          <div className={style.line}>
            <div className={style.lineBox}>
              <div className={style.lineLeft}>{t('autoSweep.networkFee')}:</div>
              <div className={style.lineRight}>
                ≤ {toThousands(detail.maxFeeLimit)} {detail.nativeSymbol}
              </div>
            </div>
          </div>
          {!isNil(detail.remainGas) && (
            <div className={style.line}>
              <div className={style.lineBox}>
                <div className={style.lineLeft}>{t('autoSweep.gas')}: </div>
                <div className={style.lineRight}>
                  {toThousands(detail.remainGas)} {detail.nativeSymbol}
                </div>
              </div>
            </div>
          )}
          <div className={style.line}>
            <div className={style.lineBox}>
              <div className={style.lineLeft}>Gas Station:</div>
              <div className={style.lineRight}>
                {detail.openGasStation ? t('autoSweep.open') : t('autoSweep.close')}
              </div>
            </div>
          </div>
          {detail.openGasStation && (
            <>
              <div className={style.line}>
                <div className={style.lineBox}>
                  <div className={style.lineLeft}>{t('autoSweep.gasStation')}:</div>
                  <div className={style.lineRight}>
                    <div>
                      {detail?.gasStationAccountName} ({t('wallet.home.assetsType')})
                    </div>
                    <div>{detail.gasStationAddress}</div>
                    <div>
                      {detail?.gasStationAccountBalance} {detail.nativeSymbol}
                    </div>
                  </div>
                </div>
              </div>
              <div className={style.line}>
                <div className={style.lineBox}>
                  <div className={style.lineLeft}>{t('autoSweep.supplementGas')}: </div>
                  <div className={style.lineRight}>
                    <div>
                      {toThousands(detail.onceRefillGas)}
                      {detail.nativeSymbol}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className={style.line}>
            <div className={style.lineBox}>
              <div className={style.lineLeft}>{t('autoSweep.aml')}:</div>
              <div className={style.lineRight}>
                {detail.forbidAml ? t('autoSweep.open') : t('autoSweep.close')}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  // 全量扫描
  function handleScan(record: AutoSweepRuleModel) {
    // scanSweep
    const modal = Modal.confirm({
      title: t('autoSweep.PerformFullScan'),
      content: (
        <div>
          <div className={style.network}>
            <NetworkLogo src={record.networkLogo} width={36} height={36} />
            <div>
              {`${record.networkName}`}
              <Tag>{`${record.blockchainTypeName}`}</Tag>
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>{t('autoSweep.fullScanDesc')}</div>
        </div>
      ),
      onOk: async () => {
        const res = await sweep.scanSweep(record.networkKey)
        if (res.success) {
          emitter.emit(REFRESH_SWEEP_RULE_LIST)
          modal.destroy()
        }
      },
      closable: true,
    })
  }
  // 提交审批
  function handleApproval(record: AutoSweepRuleModel) {
    Modal.confirm({
      title: t('autoSweep.isSubmitApproval'),
      content: t('autoSweep.ApprovalDesc'),
      closable: true,
      onOk: () => handleConfirm(record.modifyKey),
    })
  }
  // 完成提交
  async function handleConfirm(modifyKey: string) {
    const res = await sweep.submitAudit(modifyKey)
    emitter.emit(REFRESH_SWEEP_RULE_LIST)
    if (res.success) {
      const modal = Modal.info({
        icon: null,
        footer: null,
        content: (
          <div className={style.approvalBox}>
            <div className={style.top}>{t('autoSweep.confirmApproval')}</div>
            <div className={style.content}>{t('autoSweep.confirmDesc')}</div>
            <div className={style.footer}>
              <Button
                type="primary"
                style={{ width: '140px', height: '40px' }}
                onClick={() => modal.destroy()}
              >
                {t('common.complete')}
              </Button>
            </div>
          </div>
        ),
        width: 335,
      })
    }
  }
  async function handleModify(record: AutoSweepRuleModel) {
    let detail = ruleDetailMap[record.modifyKey]
    if (!detail) {
      const res = await policy.getAutoSweepRuleDetail(record.modifyKey)
      if (!res.success) {
        return
      }
      setRuleDetailMap({
        ...ruleDetailMap,
        [record.modifyKey]: res.data,
      })
      detail = res.data
    }
    setPendingModifyRule(detail)
    setOpen(true)
  }
  // 删除
  function handleDelete(record: AutoSweepRuleModel) {
    Modal.confirm({
      title: t('autoSweep.confirmDelete'),
      content: (
        <div>
          <div className={style.network}>
            <NetworkLogo src={record.networkLogo} width={36} height={36} />
            <div>
              {`${record.networkName}`}
              <Tag>{`${record.blockchainTypeName}`}</Tag>
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>
            {record.activeStatus === 1 ? t('autoSweep.deleteDesc') : t('autoSweep.deleteDesc2')}
          </div>
        </div>
      ),
      closable: true,
      onOk: async () => {
        const res = await sweep.deleteSweep(record.modifyKey)
        if (res.success) {
          handleConfirmDel(record)
          emitter.emit(REFRESH_SWEEP_RULE_LIST)
        }
      },
      icon: <img src={Delete} alt="" width={24} />,
    })
  }
  // 完成删除
  function handleConfirmDel(record: AutoSweepRuleModel) {
    const modal = Modal.info({
      icon: null,
      footer: null,
      content: (
        <div className={style.approvalBox}>
          <div className={style.top}>{t('autoSweep.completeDelete')}</div>
          <div
            className={cls({
              [style.content]: true,
              [style.delete]: record.activeStatus !== 1,
            })}
          >
            <div className={style.network}>
              <NetworkLogo src={record.networkLogo} width={36} height={36} />
              <div>
                {`${record.networkName}`}
                <Tag>{`${record.blockchainTypeName}`}</Tag>
              </div>
            </div>
            <div style={{ marginTop: '10px', minWidth: '250px' }}>
              {record.activeStatus === 1
                ? t('autoSweep.completeDeleteDesc')
                : t('autoSweep.completeDeleteDesc2')}
            </div>
          </div>
          <div className={style.footer}>
            <Button
              type="primary"
              style={{ width: '140px', height: '40px' }}
              onClick={() => modal.destroy()}
            >
              {t('common.complete')}
            </Button>
          </div>
        </div>
      ),
      width: 335,
    })
  }
  // 创建表单前的提示
  function handleTip() {
    Modal.confirm({
      title: t('common.tip'),
      content: (
        <div>
          {t('autoSweep.addDesc')}
          {baseConfig.autoSweepKnowMore && (
            <a href={baseConfig.autoSweepKnowMore} target="_blank" rel="noreferrer">
              {t('autoSweep.learnMore')}
            </a>
          )}
        </div>
      ),
      okText: t('common.continue'),
      onOk: () => {
        setPendingModifyRule(undefined)
        setOpen(true)
      },
    })
  }
  // 处理审批流
  async function handleMouseEnter(record: AutoSweepRuleModel) {
    if (!ruleDetailMap[record.modifyKey]) {
      const res = await policy.getAutoSweepRuleDetail(record.modifyKey)
      if (res.success) {
        setRuleDetailMap({
          ...ruleDetailMap,
          [res.data.modifyKey]: res.data,
        })
      }
    }
  }
  const deHandleMouseEnter = debounce(handleMouseEnter, 1000)
  const columns = [
    {
      title: t('autoSweep.network'),
      render: (record: AutoSweepRuleModel) => {
        return (
          <div className={style.network}>
            <NetworkLogo src={record.networkLogo} />
            <div>
              {`${record.networkName}`}
              <Tag>{`${record.blockchainTypeName}`}</Tag>
            </div>
          </div>
        )
      },
      width: 300,
    },
    {
      title: t('autoSweep.conditionHeader'),
      render: (record: AutoSweepRuleModel) => {
        return t('autoSweep.condition', { count: record.triggerAmountUsd })
      },
    },
    {
      title: t('autoSweep.transactionApproval'),
      render: (record: AutoSweepRuleModel) => {
        return record.auditUserDtoList.map(user => {
          return <div key={user?.userKey}>{user.userName}</div>
        })
      },
      width: 150,
    },
    {
      title: t('autoSweep.approve'),
      render: (record: AutoSweepRuleModel) => {
        const auditInfo = ruleDetailMap[record.modifyKey]?.auditInfo
        return (
          <div className={styles.stateContainer}>
            <div
              className={cls(styles.status_dot, txStatusColorClass(record.auditStatus as number))}
            />
            {auditInfo ? (
              <ApprovalFlow
                auditStatus={record.auditStatus}
                flow={auditInfo}
                renderChildren={() => (
                  <div className={styles.hover}>
                    {getAuditStatusText(record.auditStatus, record.operateType)}
                  </div>
                )}
              />
            ) : (
              <div className={styles.hover}>
                {getAuditStatusText(record.auditStatus, record.operateType)}
              </div>
            )}
          </div>
        )
      },
      onCell: (record: AutoSweepRuleModel) => {
        return {
          onMouseEnter: () => deHandleMouseEnter(record),
        }
      },
      width: 280,
    },
    {
      title: t('autoSweep.effcetive'),
      render: (record: AutoSweepRuleModel) => {
        return record.activeStatus === 1 ? t('policy.valid') : t('policy.invalid')
      },
    },
    {
      title: t('common.operation'),
      render: (record: AutoSweepRuleModel) => {
        return (
          <div>
            <Button
              type="link"
              style={{ marginRight: '40px', fontWeight: '500' }}
              disabled={record.auditStatus === AutoSweepAuditStatus.INAPPRVAL}
              onClick={() => {
                handleModify(record)
              }}
            >
              {t('common.change')}
            </Button>
            <Button
              type="link"
              style={{ fontWeight: '500' }}
              disabled={record.auditStatus === AutoSweepAuditStatus.INAPPRVAL}
              onClick={() => {
                handleDelete(record)
              }}
            >
              {t('common.delete')}
            </Button>
          </div>
        )
      },
    },
    {
      render: (record: AutoSweepRuleModel) => {
        if (
          record.auditStatus === AutoSweepAuditStatus.NOSUBMITTED ||
          (record.auditStatus === AutoSweepAuditStatus.REJECT &&
            record.operateType === AutoSweepOperateType.AUTOSWEEP_RULE_ADD)
        ) {
          return (
            <Button
              type="link"
              style={{ fontWeight: '500' }}
              onClick={() => {
                handleApproval(record)
              }}
            >
              {t('autoSweep.submitApproval')}
            </Button>
          )
        }
        if (record.activeStatus === 1) {
          return (
            <Button
              type="link"
              style={{ fontWeight: '500' }}
              onClick={() => handleScan(record)}
              disabled={record.alreadyScanStatus}
            >
              {t('autoSweep.fullScan')}
            </Button>
          )
        }
      },
      width: 150,
    },
    ATable.EXPAND_COLUMN,
  ]
  // 默认展开
  const location = useLocation()
  const modifyKey = location.state?.modifyKey
  useEffect(() => {
    if (modifyKey) {
      policy.getAutoSweepRuleDetail(modifyKey).then(res => {
        if (res.success) {
          setRuleDetailMap({
            ...ruleDetailMap,
            [res.data.modifyKey]: res.data,
          })
        }
      })
    }
  }, [modifyKey])

  const renderContent = () => {
    return !rules?.length ? (
      <div style={{ marginTop: '260px' }}>
        <Empty
          image={emptyImg}
          description={
            <div className={style.emptyDesc}>
              {t('autoSweep.desc')}
              {baseConfig.autoSweepHelp && (
                <a
                  target="_blank"
                  href={baseConfig.autoSweepHelp}
                  style={{ fontWeight: '500' }}
                  rel="noreferrer"
                >
                  {t('autoSweep.learnMore')}
                </a>
              )}
            </div>
          }
        >
          <Button type="primary" style={{ width: '180px', height: '40px' }} onClick={handleTip}>
            {t('autoSweep.addAutoSweep')}
          </Button>
        </Empty>
      </div>
    ) : (
      <div>
        <div className={style.header}>
          <div className={style.left}>{t('autoSweep.strategyList')}</div>
          <div className={style.right}>
            <WalletButton
              text={t('autoSweep.addAutoSweep')}
              icon={<img src={addAutoSweep} alt="" style={{ width: '24px', marginRight: '8px' }} />}
              onClick={handleTip}
            />
          </div>
        </div>

        <Table
          dataSource={rules}
          columns={columns}
          pagination={false}
          rowClassName={() => styles.tableBody}
          rowKey={record => record.modifyKey}
          expandable={{
            expandedRowRender: renderExpand,
            expandedRowClassName: () => {
              return styles.expandRow
            },
            async onExpand(expanded: boolean, record) {
              if (expanded && !ruleDetailMap[record.modifyKey]) {
                const res = await policy.getAutoSweepRuleDetail(record.modifyKey)
                if (res.success) {
                  setRuleDetailMap({
                    ...ruleDetailMap,
                    [res.data.modifyKey]: res.data,
                  })
                }
              }
            },
            expandIcon: ({ expanded, onExpand, record }) => {
              return (
                <div onClick={evt => onExpand(record, evt)} className={styles.expand}>
                  <div style={{ marginRight: '5px' }}>{t('common.detail')}</div>
                  <div>
                    <img
                      src={Shape}
                      alt=""
                      style={{
                        width: '10px',
                        height: 'auto',
                        transform: `rotate(${expanded ? '180' : '0'}deg)`,
                      }}
                    />
                  </div>
                </div>
              )
            },
            columnWidth: 90,
            defaultExpandedRowKeys: [modifyKey || ''],
          }}
        />
      </div>
    )
  }

  const renderSpin = () => {
    return <Spin size="large" className={styles.spin} />
  }

  return (
    <>
      {baseConfig.autoSweepHelp && (
        <a target="_blank" className={style.help} href={baseConfig.autoSweepHelp} rel="noreferrer">
          {t('common.help')}
        </a>
      )}

      <div className={style.container}>
        {rules ? renderContent() : renderSpin()}
        <SweepDrawer
          open={open}
          onClose={() => {
            setOpen(false)
            setPendingModifyRule(undefined)
          }}
          data={pendingModifyRule}
          baseConfig={baseConfig}
        />
      </div>
    </>
  )
})

export default autoSweep
